import { Table, Button, Modal, ConfirmModal } from '../../components';
import { useLiveKitServers } from './useLiveKitServers';
import { LiveKitSettingsForm } from './LiveKitSettingsForm';
import { DeleteOutline, Edit } from '@mui/icons-material';

const LiveKitServerPage = () => {
  const {
    servers,
    loading,

    isOpened,
    onOpen,
    onClose,

    adding,
    updating,
    deleting,
    handleAddServer,
    handleEditServer,

    isEdit,
    currentForm,
    setCurrentForm,

    serverForDelete,
    openedDeleteModal,
    closeDeleteModal,
    handleDeleteServer,
    openDeleteModal,
  } = useLiveKitServers();

  return (
    <div className="p-4">
      <div className="flex flex-wrap justify-end mb-4">
        <Button
          label="Create LiveKit Server"
          size="medium"
          disabled={adding}
          onClick={() => {
            setCurrentForm(undefined);
            onOpen();
          }}
        />
      </div>

      <ConfirmModal
        open={openedDeleteModal}
        onClose={closeDeleteModal}
        onConfirm={handleDeleteServer}
        title={`Delete LiveKit Server "${serverForDelete?.name || ''}"?`}
      />

      <Modal
        size="medium"
        open={isOpened}
        onClose={onClose}
        title={isEdit ? 'Edit LiveKit Server' : 'Create LiveKit Server'}
      >
        <LiveKitSettingsForm
          form={currentForm}
          setForm={setCurrentForm}
          saving={adding || updating || deleting}
          onCancel={onClose}
          onSave={isEdit ? handleEditServer : handleAddServer}
        />
      </Modal>

      <div className="overflow-x-auto">
        <Table
          data={servers || []}
          loading={loading}
          emptyMessage="No LiveKit servers found"
          config={{
            columns: [
              {
                header: 'Server Name',
                cellClassName: 'min-w-[15rem] text-left',
                getValue: ({ name }) => name || '-',
              },
              {
                header: 'URL',
                cellClassName: 'min-w-[20rem] text-left',
                getValue: ({ url }) => url || '-',
              },
              {
                header: 'API Key',
                cellClassName: 'min-w-[15rem] text-left',
                getValue: ({ apiKey }) => {
                  const key = apiKey || '';
                  return key.length > 20
                    ? `${key.substring(0, 20)}...`
                    : key || '-';
                },
              },
              {
                header: 'Actions',
                cellClassName: 'min-w-[10rem]',
                align: 'center' as const,
                getValue: server => (
                  <div className="flex items-center justify-end gap-2">
                    <Button
                      size="small"
                      type="contrast"
                      className="px-2"
                      icon={<Edit className="h-8 w-8 text-buttonPrimary" />}
                      onClick={() => {
                        setCurrentForm(server);
                        onOpen();
                      }}
                    />
                    <Button
                      size="small"
                      type="contrast"
                      className="px-2"
                      icon={
                        <DeleteOutline className="h-8 w-8 text-buttonPrimary" />
                      }
                      onClick={() => openDeleteModal(server)}
                    />
                  </div>
                ),
              },
            ],
          }}
        />
      </div>
    </div>
  );
};

export default LiveKitServerPage;
